import React, { useEffect, useState } from "react";
import { Row, Col, Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  ProgressFileStatus,
  FileStatusPayroll,
  AddToolTip,
} from "../../../components";
import { get } from "lodash";
import {
  FILE_UPLOAD_STATUS,
  getAdvancedPathWithParam,
  numberWithCommas,
  ROUTES,
  usDateFormat,
  usCurrency,
} from "../../../utils";
import upload from "../../../styles/upload.png";
import ftp from "../../../styles/ftp.png";
import create from "../../../styles/create.png";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { deleteUploadedFileById } from "../../../services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";
import { faTimes, faTrashAlt } from "@fortawesome/pro-solid-svg-icons";

const PayrollCard = (props) => {
  const history = useHistory();
  const {
    data,
    fixError,
    deleteUploadFile,
    Submit,
    View,
    setLoading,
    Continue,
    AwaitingFunding,
    pageRefresh,
    columns,
  } = props;
  const [isShow, setShow] = useState(null);
  const [deleteSlider, setDeleteSlider] = useState(false);
  const [errorType, setErrorType] = useState("");
  var showTrashIcon = true;
  useEffect(() => {
    if (
      get(data, "totalNumberOfErrors", 0) ||
      get(data, "totalNumberOfWarnings", 0)
    ) {
      setErrorType(3);
    }
    if (get(data, "totalDuplicateRecordsCount", 0)) {
      setErrorType(2);
    }
  }, [data]);

  const showPopup = (id) => {
    setShow(id);
  };
  const completedView = () => {
    history.push(
      getAdvancedPathWithParam({
        path: ROUTES.PAYROLL_REPORTS,

        pathParam: [data.id],
      })
    );
  };
  const onDeleteConfirmClick = (id) => {
    setLoading(true);
    deleteUploadedFileById(id)
      .then((response) => {
        if (response) {
          pageRefresh();
        }
      })
      .catch((error) => {
        throw error;
      });
    setDeleteSlider(false);
    setLoading(false);
  };
  const onClickCard = () => {
    return data.fileStatus === FILE_UPLOAD_STATUS.CreationInProgress
      ? Continue
      : data.fileStatus === FILE_UPLOAD_STATUS.ErrorCorrectionRequired
      ? () => fixError(data.fileStatus)
      : data.fileStatus === FILE_UPLOAD_STATUS.PendingSubmission
      ? Submit
      : data.fileStatus === FILE_UPLOAD_STATUS.AwaitingFunding
      ? AwaitingFunding
      : data.fileStatus === FILE_UPLOAD_STATUS.AwaitingFundConfirmation
      ? AwaitingFunding
      : data.fileStatus === FILE_UPLOAD_STATUS.PayrollFunded
      ? completedView
      : data.fileStatus === FILE_UPLOAD_STATUS.Completed
      ? completedView
      : data.fileStatus === FILE_UPLOAD_STATUS.StructuralValidationFailed
      ? () => fixError(data.fileStatus)
      : null;
  };
  return (
    <>
      {!deleteSlider ? (
        <div
          className={`cursor-pointer card-box border${data.fileStatus}`}
          onClick={onClickCard()}
          style={{
            height: "155px",
            paddingLeft: "0px",
            paddingTop: "0px",
            paddingRight: "0px",
            paddingBottom: "0px",
          }}
        >
          <div style={columns[0].style}>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                width: "280px",
                paddingTop: "15px",
              }}
            >
              <div className="d-flex flex-column">
                <span
                  style={{ width: "129px", height: "19px", color: "#919191" }}
                >
                  File name & details
                </span>
                <div
                  className="flex-row"
                  style={{
                    marginTop: "10px",
                    width: "24px",
                    height: "18px",
                  }}
                >
                  {data.uploadedThrough === "FileUpload" ? (
                    <OverlayTrigger overlay={<Tooltip>Uploaded</Tooltip>}>
                      <Image src={upload} />
                    </OverlayTrigger>
                  ) : data.uploadedThrough === "CreatePayroll" ? (
                    <OverlayTrigger overlay={<Tooltip>Created</Tooltip>}>
                      <Image src={create} />
                    </OverlayTrigger>
                  ) : (
                    <OverlayTrigger
                      overlay={<Tooltip>Uploaded via FTP</Tooltip>}
                    >
                      <Image src={ftp} />
                    </OverlayTrigger>
                  )}
                  <span
                    style={{
                      height: "20px",
                    }}
                  >
                    {data.fileName.length > 25 ? (
                      <OverlayTrigger
                        placement="top-start"
                        overlay={<Tooltip>{data.fileName}</Tooltip>}
                      >
                        <p
                          className=" para-wrap two-lines d-flex"
                          style={{
                            marginTop: "0px",
                            marginLeft: "6px",
                            width: "350px",
                            fontWeight: "bold",
                            fontSize: "14px",
                          }}
                        >
                          {(data.fileName || "").slice(0, 15)}...
                          {(data.fileName || "").slice(
                            data.fileName.length - 16,
                            data.fileName.lastIndexOf(".")
                          )}
                          <p
                            className="font-weight-500"
                            style={{ color: "grey" }}
                          >
                            {(data.fileName || "").slice(
                              data.fileName.lastIndexOf("."),
                              data.fileName.length
                            )}{" "}
                          </p>
                        </p>
                      </OverlayTrigger>
                    ) : (
                      <p
                        className="ft-12 para-wrap two-lines d-flex"
                        style={{
                          marginTop: "6px",
                          marginLeft: "10px",
                          width: "350px",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {data.fileName.slice(0, data.fileName.lastIndexOf("."))}
                        <p
                          className="font-weight-500"
                          style={{ color: "grey" }}
                        >
                          {data.fileName.slice(
                            data.fileName.lastIndexOf("."),
                            data.fileName.length
                          )}{" "}
                        </p>
                      </p>
                    )}
                  </span>
                </div>
              </div>

              <div
                className="d-flex justify-content-between"
                style={{
                  marginTop: "15px",
                }}
              >
                <div>
                  <p className="ft-12 dark-grey-text font-weight-500">
                    {moment(new Date(data.uploadedOn)).fromNow()}
                  </p>
                </div>
                <div className="mr-2 ft-12 grey-text">
                  <p>
                    &nbsp;&nbsp;&nbsp; | &nbsp;
                    {usDateFormat(moment(data.uploadedOn))}
                  </p>
                </div>
                <div className="mr-2 ft-12 grey-text">
                  <p>{moment(new Date(data.uploadedOn)).format("hh:mm A")}</p>
                </div>
              </div>
              <p
                style={{
                  width: "450px",
                  height: "35px",
                  fontSize: "12px",
                  color: "#919191",
                }}
              >
                {" "}
                {data?.description?.length > 100 ? (
                  <AddToolTip
                    //className="link-text"
                    name={data?.description}
                    //direction='bottom'
                    placement="bottom"
                  >
                    {(data?.description || "").slice(0, 50)}...
                  </AddToolTip>
                ) : (
                  <>{data?.description}</>
                )}
              </p>
            </div>
          </div>
          <div
            style={{ borderLeft: "1px solid #D8D8DC", height: "154px" }}
          ></div>
          <div style={columns[1].style}>
            <div
              className="d-flex flex-col"
              style={{
                width: "220px",
                marginRight: "10px",
                marginTop: "15px",
                marginLeft: "20px",
              }}
            >
              {data.companyName && (
                <div
                  className="flex-row grey-text"
                  style={{ width: "129px", height: "15px" }}
                >
                  Company Name
                </div>
              )}
              <div
                className="flex-row"
                style={{ width: "129px", height: "18px" }}
              >
                <p
                  className="ft-14 black-text font-weight-400 title-wrap mbb-5"
                  style={{
                    width: "180px",
                    height: "20px",
                    marginTop: "5px",
                  }}
                >
                  <AddToolTip name={data.companyName} />
                </p>
              </div>
              <div
                className="flex-row grey-text"
                style={{
                  width: "129px",
                  height: "15px",
                  marginTop: "5px",
                }}
              >
                Plan details
              </div>
              <div className="flex-row">
                {data.planName === null && (
                  <p
                    className="ft-14 black-text font-weight-400 title-wrap mbb-5 mt-10"
                    style={{
                      width: "230px",
                      marginTop: "10px",
                      fontSize: "14px",
                    }}
                  >
                    Plan not found
                  </p>
                )}
                <p
                  className="ft-14 black-text font-weight-400 title-wrap mbb-5"
                  style={{
                    width: "150px",
                    height: "20px",
                    marginTop: "10px",
                  }}
                >
                  <AddToolTip name={data.planName} />
                </p>
              </div>
              <div className="flex-row">
                {data.planName && (
                  <p className="ft-14 black-text font-weight-400 mbb-5">
                    <span className="grey-text ft-14 pr-1">ID:</span>
                    {""}
                    {data.rkPlanNumber}
                  </p>
                )}
              </div>

              {data.planName !== null && (
                <div className="flex-row w-100">
                  <p className="font-weight-400 flex-column">
                    <div
                      className="grey-text ft-14"
                      style={{
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Group Name:
                    </div>
                  </p>
                  <p
                    className="ft-14 black-text font-weight-400 title-wrap mbb-5 flex-column"
                    style={{ paddingLeft: "0.313rem" }}
                  >
                    <AddToolTip name={data.planGroupNames} />
                  </p>
                </div>
              )}
            </div>
          </div>

          <div style={columns[2].style}>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "column",
                width: "130px",
                marginTop: "15px",
              }}
            >
              <p
                style={{
                  color: "#919191",
                  fontSize: "14px",
                  marginBottom: "5px",
                }}
              >
                Profile Name
              </p>
              <div
                style={{
                  marginBottom: "6px",
                  color: "black",
                  fontSize: "12px",
                  whiteSpace: "pre-wrap",
                  overflowWrap: "break-word",
                }}
              >
                <div style={{ width: "129px", height: "19px" }}>
                  <p
                    className="ft-14 black-text font-weight-400 title-wrap mbb-5"
                    style={{
                      width: "180px",
                      height: "16px",
                      marginTop: "10px",
                    }}
                  >
                    <AddToolTip name={data.profileName} />
                  </p>
                </div>
                {/* <div
                style={{
                  width: "129px",
                  height: "15px",
                  color: "#919191",
                  marginTop: "15px",
                }}
              ></div> */}

                {/* <AddToolTip name={data.profileName} /> */}
              </div>
            </div>
            <div
              style={{
                color: "#919191",
                height: "19px",
                fontSize: "14px",
                marginBottom: "5px",
              }}
            >
              Payroll details
            </div>
            <div
              className="light-black ft-14 font-weight-500"
              style={{ display: "flex", width: "100px", marginBottom: "6px" }}
            >
              {data.payDate.replaceAll("-", "/")}
            </div>
            <div
              className="grey-text ft-14 font-weight-500"
              style={{ marginBottom: "3px" }}
            >
              {data.payrollFrequencyName.substring(
                0,
                data.payrollFrequencyName.length - 8
              )}
            </div>
          </div>
          <div style={columns[3].style}>
            <p
              style={{
                color: "#919191",
                fontSize: "14px",
                marginBottom: "5px",
              }}
            >
              Total Amount
            </p>
            <div
              style={{
                marginBottom: "6px",
                color: "black",
                fontSize: "14px",
              }}
            >
              <AddToolTip name={usCurrency(data.totalAmount)} />
            </div>
          </div>

          <FileStatusPayroll
            showTrash={showTrashIcon}
            setLoading={setLoading}
            stepperDetails={data.progress}
            status={data.fileStatus}
            errorType={errorType}
            errors={get(data, "totalNumberOfErrors", 0)}
            warnings={get(data, "totalNumberOfWarnings", 0)}
            fileStatus={data.fileStatus}
            warningCount={data.totalNumberOfWarnings}
            errorCount={data.totalNumberOfErrors}
            duplicatesCount={data.totalDuplicateRecordsCount}
            onRemove={() => showPopup(data.id)}
            menu="payroll"
            data={data}
            // pageRefresh={pageRefresh}
            deleteUploadedFileById={deleteUploadedFileById}
            setDeleteSlider={setDeleteSlider}
            columns={columns}
          />
        </div>
      ) : (
        <div
          className={"cursor-pointer d-flex card-box"}
          style={{
            height: "154px",
            padding: "15px 0px 0px, 15px",
            background: "rgba(196, 6, 26, 0.1)",
          }}
        >
          <div className="d-flex pt-2">
            <span className="mt-3 mr-3">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                size="lg"
                color="#C4061A"
              />
            </span>
            <div className="d-flex flex-col">
              <span>Delete Payroll File</span>
              <span className="ft-12">
                Are you attempting to delete payroll file ?
              </span>
              <span className="fw-500">{data.fileName}</span>
            </div>
          </div>
          <div className="d-flex mt-3 pt-3">
            <span
              className="mr-3"
              style={{ color: "#C4061A" }}
              onClick={() => onDeleteConfirmClick(data.id)}
            >
              <FontAwesomeIcon icon={faTrashAlt} className="mr-2" />
              Delete
            </span>
            <span className="ml-3 mr-3" onClick={() => setDeleteSlider(false)}>
              <FontAwesomeIcon icon={faTimes} className="mr-2" />
              Cancel
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export default PayrollCard;
